import './page-loader.scss';

function PageLoader() {
    return (
        <div className="LoaderMain">
            <div class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
}
export default PageLoader;
